import securedAxios from '~/javascript/utils/axios'

const axios = securedAxios()

export function runFinalAudit(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/run_final_audit`)
}

export function getFinalAudit(pageId) {
  return axios.get(`/ajax/website_pages/${pageId}/final_audit`)
}

export function acceptFinalAudit(pageId) {
  return axios.post(`/ajax/website_pages/${pageId}/accept_final_audit`)
}

export function downloadDeliverable(pageId, type) {
  return axios.get(`/ajax/website_pages/${pageId}/download_deliverable`, {
    params: { type },
    responseType: 'blob'
  })
}
